import { usePageTitle } from 'hooks';
import { config } from 'config';
import Layout from 'layouts';
import { StyledContainer, StyledIFrame } from './WinASlice.styles';

const { winASliceUri } = config;

const WinASlice = () => {
  usePageTitle('Win A Slice');

  return (
    <Layout ariaLabel="Win A Slice">
      <StyledContainer>
        <StyledIFrame src={winASliceUri} title="Win A Slice" />
      </StyledContainer>
    </Layout>
  );
};

export default WinASlice;
